<template>
  <tr @click.stop="toggleActive" :class="computedClasses">
    <td v-if="hasCheckbox" style="border-right:1px solid #C4C4C4;padding: 0 10px">
      <AppCheckbox :checked="isActive"
                   @toggle-check="toggleActive"/>
    </td>
    <td v-for="(item, index) in values" :key="index" @click.stop="showItem" :class="item.mod">
      <div class="cell-inner" v-if="item.mod === 'colorCell'">
        <span class="cell-data colorCell-item" :style="`background-color: ${ item.data }`"></span>
      </div>
      <div class="cell-inner" v-else-if="item.mod === 'avatar'">
        <span style="display:flex; align-items: center">
          <div class="user-avatar dialog-avatar" style="margin-right:12px">
            <img v-if="item.data.avatar"
                :src="item.data.avatar.url" :alt="item.data.avatar.full_name">
            <img v-else src="/img/svg/avatar__icon.svg">
          </div>

          <div v-if="item.data && item.data.profile">
            {{ item.data.profile.full_name }}
          </div>
        </span>
      </div>
      <div v-else-if="item.mod === 'status'">
        <div v-if="item.data.status">
          {{ item.data.status.name }}
        </div>
          <!-- статус в сети -->
          <!-- <div class="line-status online" v-if="item.data.difference_auth_at && item.data.difference_auth_at < 300">online</div>
          <div class="line-status offline" v-else>offline</div> -->
      </div>
      <div class="cell-inner" v-else-if="item.mod === 'colorText'">
        <span class="cell-data colorText" :style="`color: ${ item.data.color }`">{{item.data.name}}</span>
      </div>
      <div class="cell-inner" v-else-if="item.mod === 'pvhComments'">
        <span class="cell-data">{{ item.data[0] }}</span>
        <span class="cell-data" style="display: block; width: max-content; font-size: 12px;" v-if="item.data[1]">{{ item.data[1] }}</span>
      </div>
      <div class="cell-inner" v-else-if="item.mod === 'fuel'">
        <p class="cell-data" style="font-size: 12px;" v-for="fuel in item.data" :key="fuel.id">
          <strong>{{fuel.fuel.name}}:</strong> {{fuel.balance_at}}/{{fuel.balance_to}}
        </p>
<!--        <span class="cell-data">{{ item.data[0] }}</span>-->
<!--        <span class="cell-data" style="display: block; width: max-content; font-size: 12px;" v-if="item.data[1]">{{ item.data[1] }}</span>-->
      </div>
      <div class="cell-inner" v-else>
        <span class="cell-data">{{  typeof item === 'object' ? item.data || '-' : item || '-' }}</span>
      </div>
    </td>
    <td class="table__menu-cell" v-if="isMenuControlsActive">
      <div>
        <div class="table__menu" @click="toggleControls">
          <svg class="ellipsis-icon" viewBox="0 0 23 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2" cy="2" r="2" fill="currentColor"/>
            <circle cx="11" cy="2" r="2" fill="currentColor"/>
            <circle cx="21" cy="2" r="2" fill="currentColor"/>
          </svg>
        </div>
        <div class="table__controls">
          <transition name="fade">
            <AppPopupControls v-if="isControlsActive"
                              :active-buttons="{add: menuControls.add, edit: menuControls.update, remove: menuControls.remove}"
                              @edit-this-item="editItem"
                              @remove-this-item="removeItem"
            />
          </transition>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import AppPopupControls from '../popup/AppPopupControls.vue'
import AppCheckbox from '@/components/page/input/AppCheckbox'
// import { mapGetters } from 'vuex'
export default {
  name: 'app-table-special-elem',
  components: {
    AppPopupControls,
    AppCheckbox
  },
  props: {
    hasCheckbox: {
      type: Boolean,
      default: false
    },
    isActive: Boolean,
    isWarning: Boolean,
    isDeactive: Boolean,
    isControlsActive: Boolean,
    isMenuControlsActive: {
      type: Boolean,
      default: true
    },
    menuControls: {
      type: Object,
      default: () => ({
        add: false,
        update: true,
        remove: true
      })
    },
    itemId: {
      type: [Number, String]
    },
    values: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // ...mapGetters({
    //   currentPage: 'getCurrentPage'
    // }),
    currentUser () {
      return this.$store.getters.currentUser
    },
    computedClasses () {
      return {
        tr_active: this.isActive,
        tr_warning: this.isWarning,
        tr_deactive: this.isDeactive
      }
    }
  },
  methods: {
    toggleControls () {
      this.$emit('toggle-controls')
    },
    toggleActive () {
      this.$emit('toggle-active')
    },
    editItem () {
      this.$emit('edit-this-item')
    },
    removeItem () {
      this.$emit('remove-this-item')
    },
    showItem () {
      this.$emit('show-this-item')
    },
    showChildItem (itemId) {
      console.log(itemId)
      this.$emit('show-this-child-item', itemId)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../assets/css/system/_vars';
  @import '../../../assets/css/system/_mixins';

  @import './_table';

  tr {
    cursor: pointer;
  }

  /* колличество дочерних задач в списке задач */
  .task-child-count .cell-inner {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .task-child-count .cell-data {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // pvh
  .pvh-bold {
    font-weight: bold;
  }

  a.pvh-link {
    color: #204da9;

    &:hover {
      color: #ffd9a2;
      text-decoration: underline;
    }
  }

  .colorCell-item {
    width: 40px;
    height: 18px;
    display: block;
  }

  .online {
    color: $color_fourth;

    &:before {
      background: $color_fourth;
      background: $color_fourth_gradient;
    }
  }

  .offline {
    color: $color_fifth;

    &:before {
      background: $color_fifth;
      background: $color_fifth_gradient;
    }
  }

  .line-status {
    font-size: 14px;
    font-weight: bold;

    &:before {
      content: '';
      display: inline-block;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
</style>
